module.exports = __webpack_public_path__ + "fonts/Inter-200-cyrillic-ext29.251d36f.woff2";